import { h, render, FunctionComponent } from 'preact';
import { EndPointKeys, getApi } from '../../../src/ts/libs/getApi';
import { useFetch } from '../hooks/useFetch';

type Icon = 'cart' | 'reorder';
interface ActionButtonProps {
  label: string;
  icon?: Icon;
  extraClasses?: string;
  endpoint: EndPointKeys;
  payload?: any;
}
export const ActionButton: FunctionComponent<ActionButtonProps> = ({
  label,
  icon,
  endpoint,
  payload,
  extraClasses = '',
}) => {
  const { loading, fetchData, response, error } = useFetch(`${getApi(endpoint)}`, {});

  const handleAction = async () => {
    await fetchData({
      method: 'POST',
      body: JSON.stringify({
        ...payload,
      }),
    });

    const event = new Event('basket-update');
    window.dispatchEvent(event);
  };
  // Do we have a payload ... if not we don't need to show the button

  if (
    !payload ||
    (Object.keys(payload).length === 0 && payload.constructor === Object) ||
    (Array.isArray(payload) && payload.length < 1)
  ) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleAction}
      className={`button button--primary button--icon-left ${extraClasses} ${loading ? 'is-loading' : ''}`}
      data-test="action-btn"
    >
      {icon && icon === 'cart' && (
        <svg viewBox="0 0 36 32" width={24} height={22} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m39.0075 26.8324375 2.9545625-13c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-24.548875l-.572875-2.800625c-.14275-.6980625-.757-1.199375-1.4695625-1.199375h-6.4080625c-.8284375 0-1.5.6715625-1.5 1.5v1c0 .8284375.6715625 1.5 1.5 1.5h4.3676875l4.3905 21.4646875c-1.050375.6040625-1.7581875 1.7366875-1.7581875 3.0353125 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-.979625-.4029375-1.8646875-1.0515-2.5h13.1029375c-.6485.6353125-1.0514375 1.520375-1.0514375 2.5 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-1.38575-.8055-2.58325-1.9736875-3.1503125l.3448125-1.51725c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-16.776125l-.4090625-2h18.3215625c.700375 0 1.3075-.484625 1.4626875-1.1675625z"
            fill="currentColor"
            fillRule="evenodd"
            transform="translate(-6 -8)"
          />
        </svg>
      )}
      {icon && icon === 'reorder' && (
        <svg height={16} width={16} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <path
              d="M11.7 4.041a5.38 5.38 0 00-3.705-1.46 5.426 5.426 0 00-5.251 4.092.388.388 0 01-.376.295H.519a.387.387 0 01-.38-.458 8.002 8.002 0 0113.387-4.294l1.152-1.152A.774.774 0 0116 1.61v4.324a.774.774 0 01-.774.775H10.9a.774.774 0 01-.547-1.322zM.775 9.291H5.1c.69 0 1.035.833.547 1.321L4.3 11.959a5.38 5.38 0 003.706 1.46 5.426 5.426 0 005.251-4.092.388.388 0 01.376-.295h1.849c.241 0 .425.22.38.458a8.002 8.002 0 01-13.387 4.294l-1.152 1.152A.774.774 0 010 14.39v-4.324c0-.428.347-.775.774-.775z"
              fill="#25252d"
            />
          </g>
        </svg>
      )}

      <span className="button__label">{error ? 'Error' : label}</span>
    </button>
  );
};

try {
  const domContainers = document.querySelectorAll('.action-button');

  Array.from(domContainers).forEach((domContainer) => {
    const label = domContainer.getAttribute('data-label');
    const icon = domContainer.getAttribute('data-icon') as Icon;
    const endpoint = domContainer.getAttribute('data-endpoint') as EndPointKeys;
    const payloadId = domContainer.getAttribute('data-payload-id') as any;
    const extraClasses = domContainer.getAttribute('data-classes') as any;
    const payloadElement = payloadId ? document.getElementById(payloadId) : null;
    const payload = payloadElement ? JSON.parse(payloadElement.innerHTML) : {};

    render(
      <ActionButton label={label} icon={icon} endpoint={endpoint} extraClasses={extraClasses} payload={payload} />,
      domContainer
    );
  });
} catch (e) {
  console.warn(e);
}
